import { gql } from "@apollo/client";

export const CREATE_ACTIVITY_FROM_EMPTY = gql`
  mutation createActivityFromEmptyActivity(
    $model: InsertEmptyActivityInput
  ) {
    createActivityFromEmptyActivity(model: $model) {
      activity {
        activityId
        guid
        planDateTime
        updateVersion
        activityType {
          activityTypeId
          displayName
          guid
          activityTypeStatements {
            activityTypeStatementId
            statementCode
            informationText
            guid
          }
        }
        activityStatus {
          activityStatusId
          displayName
          guid
          activityStatusWorkflowToActivityStatusesWf {
            toActivityStatusId
            workflowId
            fromActivityStatus {
              activityStatusId
            }
          }
          activityStatusWorkflowFromActivityStatuses {
            fromActivityStatusId
          }
          activityStatusWorkflowToActivityStatuses {
            displayName
            guid
            activityStatusWorkflowFromActivityStatuses {
              toActivityStatusId
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_ACTIVITY_STATEMENT = gql`
  mutation updateActivityStatement($model: UpdateActivityStatementInput) {
    updateActivityStatement(model: $model) {
      updatedStatement {
        activityStatement {
          value
        }
      }
    }
  }
`;

export const UPDATE_ACTIVITY_FROM_EMPTY = gql`
  mutation updateActivityFromEmptyActivity(
    $model: InsertEmptyActivityInput
  ) {
    updateActivityFromEmptyActivity(model: $model) {
      activity {
        activityId
      }
    }
  }
`;

export const UPDATE_ACTIVITY_STATUS = gql`
  mutation updateActivityStatus($model: UpdateActivityStatusInput!) {
    updateActivityStatus(model: $model) {
      activity {
        activityId
        guid
      }
    }
  }
`;

export const REMOVE_ACTIVITY_DOCUMENT = gql`
  mutation deleteActivityDocument($model: DeleteActivityDocumentInput) {
    deleteActivityDocument(model: $model) {
      response
    }
  }
`;

export const SIGNUP = gql`
  query Signup($model: SignupInput) {
    signup(model: $model) {
      response
      refresh
      expireHours
      userInfo {
        salesPersonId
        salesPersonGuid
        salesPersonName
        salesRegionHierarchyCode
        salesRegionReference
        salesRegionDisplayName
        roles
        tenantId
        rolesGuids
      }
    }
  }
`;

export const INSERT_CUSTOMER = gql`
  mutation insertCustomer($model: InsertCustomerInput) {
    insertCustomer(model: $model) {
      customer {
        customerId
        displayName
        brandName
        addressCity
        addressLine1
      }
    }
  }
`;

export const UPDATE_SALESPERSON = gql`
  mutation updateSalesPerson($model: UpdateSalesPersonInput) {
    updateSalesPerson(model: $model) {
      salesPerson {
        salesPersonId
        worksInCustomerId
      }
    }
  }
`;